import underscored from 'underscore.string/underscored';

angular.module('filters').filter('underscored', function() {
  return function(data) {
    return underscored(data);
  };
});
